import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";

const Etymology = () => {
  return (
    <div className="reduce-width">
      {AddPageHeader("Etymology and history")}
      <Divider align="center">
        <h1>Etymology and history</h1>
      </Divider>
      <div className="privacy-terms-reduced-width">
        <p>
          The terms <i>consul</i>, <i>consular</i>, and <i>consulate</i> have
          roots in both Roman governance and the evolution of diplomacy.
        </p>
        <p>
          <b>Roman origins</b>
        </p>
        <p>
          The word <i>consul</i> originates from the Latin consul, which is
          derived from the verb <i>consulere</i>, meaning "to consult" or "to
          take counsel." In the Roman Republic (509 BCE – 27 BCE), consuls were
          the highest elected officials, typically two in number, who shared
          executive power for one-year terms. Their responsibilities included
          commanding armies, presiding over the Senate, and overseeing the
          administration of justice. This dual leadership structure was designed
          to prevent the concentration of power in any one individual, as
          consuls acted as checks on each other’s authority. The term{" "}
          <i>consular</i> refers to anything related to the consul’s office or
          duties, including diplomatic roles. The word <i>consulate</i>, derived
          from <i>consulatus</i>, originally referred both to the office of
          consul and to the period during which they served.
        </p>
        <div style={{ textAlign: "center" }}>
          <img
            src="images/Rome.png"
            alt="Rome"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
        <p>
          <b>Consul in the early modern period</b>
        </p>
        <p>
          From the 16th to the 19th centuries, the meaning of <i>consul</i>{" "}
          shifted significantly as the world saw the rise of international trade
          and colonial empires. During this period, consuls were appointed by
          states primarily to safeguard their nationals' interests and
          facilitate commerce abroad. As overseas trade and colonialism
          expanded, consuls took on more diplomatic roles, acting as
          intermediaries between their home countries and foreign powers. The
          consular office became increasingly important, with consulates
          established in strategic ports and cities.
        </p>
        <div style={{ textAlign: "center" }}>
          <img
            src="images/Guangzhou.png"
            alt="Guangzhou"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
        <p>
          <b>Modern sense</b>
        </p>
        <p>
          In today’s globalized world, consul, consular, and consulate have
          adapted. While the words retain their Roman heritage, they now reflect
          a legal and bureaucratic structure for managing international
          relations and supporting citizens across the globe.
        </p>
      </div>
    </div>
  );
};

export default Etymology;
